import { Outlet } from 'react-router-dom';
import Sidebar from '../Sidebar';
import { useEffect, useState } from 'react';

const CONTEXT_SIDEBAR_STORAGE_KEY = 'ui_context_sidebar_pinned';

function readContextSidebarPinned() {
  if (typeof window === 'undefined') return true;
  const value = window.localStorage.getItem(CONTEXT_SIDEBAR_STORAGE_KEY);
  return !['0', 'false', 'off', 'no'].includes(String(value || '').toLowerCase());
}

const AppShell = () => {
  const [contextSidebarPinned, setContextSidebarPinned] = useState(readContextSidebarPinned);

  useEffect(() => {
    window.localStorage.setItem(CONTEXT_SIDEBAR_STORAGE_KEY, contextSidebarPinned ? '1' : '0');
  }, [contextSidebarPinned]);

  return (
    <div className="flex min-h-screen bg-gray-50">
      <Sidebar contextSidebarPinned={contextSidebarPinned} onToggleContextSidebar={() => setContextSidebarPinned((old) => !old)} />
      <div className={`flex-1 transition-all duration-200 ${contextSidebarPinned ? 'md:pl-[21rem]' : 'md:pl-20'}`}>
        <main className="p-6">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default AppShell;
